<template>
  <div class="container pt-5 pb-5">
    <div class="row pb-4 ">
        <div class="col-xs-1 col-md-8">
            <div class="col-12 text-center text-lg-start"><h1 class="pstitle">Boat Details</h1></div>
            <div class="text-center py-4 ">
                <carousel-control v-if="this.boat?.boatImages && this.boat.model" :images-collection="this.boat?.boatImages" :model="this.boat?.model" :aspect-ratio-width="16" :aspect-ratio-height="9" />
            </div>
        </div>
      <div class="col-xs-1 col-md-4">
        <contact-seller :hin="boat?.hin" />
      </div>
    </div>   
      <accordion-list @resize="handleScroll">
          <accordion-item name="DESCRIPTION" :selected="groupId==='group-0'" :id="'group-0'" @resize="handleScroll" :key="'group_0'">
              <div class="px-4">Make: {{ boat?.brand }}</div>
              <div class="px-4">Model: {{ formatModel(boat?.model) }}</div>
              <div class="px-4">HIN: {{ boat?.hin }}</div>
              <div class="px-4">Year: {{ boat?.modelYear }}</div>
              <div class="px-4">Length: {{ boat?.length }}</div>
              <div class="px-4" v-if="boat?.price > 0">
                  Starting At Price: ${{ formatPrice(boat?.price) }} USD
              </div>
              <div class="px-4" v-if="boat?.price == null || boat?.price == 0">
                  Starting At Price: Call for pricing
              </div>
          </accordion-item>
        <accordion-item name="SELLER INFORMATION" :selected="groupId==='group-1'" :id="'group-1'" @resize="handleScroll" :key="'group_1'">
          <div class="px-4">{{this.Address.AddressLine1}}</div>
          <div class="px-4">{{this.Address.AddressLine2}}</div>
          <div class="px-4">{{this.Address.City}}, {{this.Address.State}} {{this.Address.ZipCode}}</div>
          <div class="px-4" >{{this.Address.Country}}</div>
          <div class="px-4" v-if="this.Contacts.SalesContact === this.Contacts.ServicesContact">{{phoneNo}}: {{this.Contacts.SalesContact}}</div>
          <div class="px-4" v-else>
            <div>{{salesNo}}: {{this.Contacts.SalesContact}}</div>
            <div>{{serviceNo}}: {{this.Contacts.SalesContact}}</div>
          </div>
        </accordion-item>
        <accordion-item name="OPTIONS" :selected="groupId==='group-2'" :id="'group-2'" @resize="handleScroll" :key="'group_2'">
          <div v-for="item in boat?.boatOptions" :key="item.id" class="px-4">{{ item?.options }}</div>
        </accordion-item>
      </accordion-list>
  </div>
</template>

<script>
import getEndPoint, { boatDetails } from "../../constants/api.config";
import ContactSeller from "../../components/InputForms/ContactSeller.vue";
import CarouselControl from '../../components/CarouselControl.vue';
import AccordionList from "../../components/atoms/AccordionList.vue";
import AccordionItem from "../../components/atoms/AccordionItem.vue";
import { salesNo, serviceNo, phoneNo } from '../../constants/labels.config';
import StringUtils from "../../helpers/StringUtils";

export default {
  name: "BoatDetails",
  components:{
    ContactSeller,
    CarouselControl,
    AccordionList,
    AccordionItem
  },
  props: {
    id: null,
  },
  data() {
    return {
      boat: null,
      salesNo, 
      serviceNo,
      phoneNo,
      groupId:'group-0',
      Address: {
        Title: "",
        AddressLine1: "",
        AddressLine2: "",
        Country: "",
        State: "",
        City: "",
        ZipCode: "",
      },
      Contacts: {
        SalesContact: "",
        ServicesContact: ""
      }
    };
  },
  methods: {
    getBoatDetails() {
      this.axios
        .get(getEndPoint(boatDetails) + this.id)
        .then((response) => {
          this.boat = response.data.data[0];
          console.log(this.boat);
        })
        .catch((err) => console.log(err));
    },
    handleScroll(data){
      console.log(data)
    },
    formatPrice(price) {
        return StringUtils.formatPrice(price);
    },
    formatModel(model) {
        return StringUtils.formatModel(model);
    }
  },
  mounted() {
    this.getBoatDetails();
    this.Address.Title = window.DEALER_LOCATION.name;
    this.Address.AddressLine1 = window.DEALER_LOCATION.address.addressLine1;
    this.Address.AddressLine2 = window.DEALER_LOCATION.address.addressLine2;
    this.Address.Country = window.DEALER_LOCATION.address.country;
    this.Address.State = window.DEALER_LOCATION.address.state;
    this.Address.City = window.DEALER_LOCATION.address.city;
    this.Address.ZipCode = window.DEALER_LOCATION.address.postalCode;
    this.Contacts.SalesContact = window.DEALER_LOCATION.salesPhoneNo;
    this.Contacts.ServicesContact = window.DEALER_LOCATION.servicePhoneNo;
  },
};
</script>
<style lang="scss" scoped>
img{
  max-width: 100%;
  max-height: 100%;
  /*display: block;  remove extra space below image */
}
</style>